import React from "react";
import { Helmet } from "react-helmet-async";
import { useStore } from "../context/StoreContext";
import BLOG_POSTS from "../data/blogPosts";
import "./Blog.css";

const SITE = "https://cityshopingcenter.com";
const BASE_NAME = "City Shopping Center & Dulha House";

/* Deterministic date formatting.
   toLocaleDateString() depends on the environment's locale/timezone, so it
   produced a different string during the react-snap prerender than in the
   browser. That mismatch was causing React hydration errors #418/#423.
   Formatting manually guarantees both sides render identical text. */
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const fmtDate = (iso) => {
  try {
    const parts = String(iso).split("-");
    if (parts.length !== 3) return iso;
    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const d = parseInt(parts[2], 10);
    if (!y || !m || !d || m < 1 || m > 12) return iso;
    return d + " " + MONTHS[m - 1] + " " + y;
  } catch {
    return iso;
  }
};

export default function Blog() {
  const { viewBlogPost } = useStore();

  return (
    <div className="blog-page">
      <Helmet>
        <title>{"Jewellery Blog & Buying Guides | Artificial Jewellery Care Tips Pakistan"}</title>
        <meta
          name="description"
          content="Artificial jewellery care tips, ring size guides and bridal jewellery advice from 20+ years of experience — American Diamond, zircon and fancy jewellery guides for Pakistan."
        />
        <link rel="canonical" href={`${SITE}/blog`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Jewellery Blog & Buying Guides — " + BASE_NAME} />
        <meta property="og:url" content={`${SITE}/blog`} />
      </Helmet>

      <div className="page-header" data-echo="BLOG">
        <h1>ARTIFICIAL JEWELLERY BLOG &amp; BUYING GUIDES</h1>
        <p>Jewellery care tips, ring size &amp; bridal jewellery buying guides from 20+ years of experience</p>
      </div>

      <div className="blog-list">
        {BLOG_POSTS.map((post, bi) => (
          <article key={post.slug} className="blog-card" data-reveal="up" style={{ transitionDelay: (bi * 0.07) + "s" }} onClick={() => viewBlogPost(post.slug)}>
            <div className="blog-card-meta">
              <span>{fmtDate(post.date)}</span>
              <span className="blog-card-dot">·</span>
              <span>{post.readTime}</span>
            </div>
            <h2 className="blog-card-title">{post.title}</h2>
            <p className="blog-card-excerpt">{post.excerpt}</p>
            <span className="blog-card-readmore">Read Article →</span>
          </article>
        ))}
      </div>
    </div>
  );
}
